import React, { useEffect, useState, ChangeEvent } from 'react';
import Button from '@material-ui/core/Button';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Radio, { RadioProps } from '@material-ui/core/Radio';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { DeviceRegistPageStyle } from './DeviceRegistStyle';

const buttonStyle = {
  maxWidth: '180px',
  maxHeight: '35px',
  minWidth: '180px',
  minHeight: '35px',
};

type Props = {
  onClickSaveButton: () => void;
  onClickCancelButton: () => void;
  onClickReadCSVButton: (fileObject: File) => void;
  buttonEnable: boolean;
};

const DeviceRegistFooter: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const pageStyle = DeviceRegistPageStyle();

  /**
   * ファイル選択ダイアログ処理
   * @param e
   * @returns
   */
  const OnFileSelectAction = (e: ChangeEvent<HTMLInputElement>) => {
    console.debug(['DeviceRegistFooter - OnFileSelectAction']);
    if (!e.target.files || e.target.files.length === 0) {
      return;
    } else {
      const file: File = e.target.files[0];
      props.onClickReadCSVButton(file);
      e.target.value = '';
    }
  };

  return (
    <Grid
      container
      justify="flex-start"
      spacing={1}
      direction="row"
      alignItems="center"
      style={{ width: 'calc(100vw - 12px)' }}
    >
      <Grid item xs={2}>
        <Button
          id="fileReadButton"
          component="label"
          variant="contained"
          color="primary"
          disabled={!props.buttonEnable}
          className={pageStyle.buttonStyle}
          disableElevation
        >
          {t('DeviceRegistFooter.管理台帳読込', '管理台帳読込')}
          <input type="file" accept=".csv" hidden onChange={OnFileSelectAction} />
        </Button>
      </Grid>
      <Grid item xs={2}>
        <Button
          className={pageStyle.buttonStyle}
          variant="contained"
          color="primary"
          disabled={!props.buttonEnable}
          onClick={(e) => {
            props.onClickSaveButton();
          }}
        >
          {t('DeviceRegistFooter.保存', '保存')}
        </Button>
      </Grid>
      <Grid item xs={2}>
        <Button
          className={pageStyle.buttonStyle}
          variant="contained"
          color="primary"
          disabled={!props.buttonEnable}
          onClick={(e) => props.onClickCancelButton()}
        >
          {t('DeviceRegistFooter.中止', '中止')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default DeviceRegistFooter;
